import Api from "../config/Api";
import { BackendApiInstance } from "../config/Interceptor";
export function getSellerVehicleList(req) {
  return BackendApiInstance.get(`${Api.sellerVehicleList}`,{
    params:req
  });
}
